
import styled from "styled-components"

export const HtmlEditorContainer = styled.div`
// div[role=application] {
//     width: calc(100vw - 100px);
// }
`

export const FavoriteClassLabel = styled.label`
    color: rgb(138, 138, 138);
    font-size: 17px;
    font-weight: 400;
    margin-top: 5px;
    margin-left: 4px;
    font-style: italic;
`

export const ErrorMessage = styled.div`
    color: rgb(194, 10, 10);
    font-weight: 400;
    margin-top: 5px;
    margin-top: 3px;
`